// extracted by mini-css-extract-plugin
module.exports = {"Group":"styles_Group__2HGqu","Group--50":"styles_Group--50__sKUY_","Group-content":"styles_Group-content__37a7k","Group--33":"styles_Group--33__1W3qL"};